// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sourceSans3_11930e', '__sourceSans3_Fallback_11930e', Arial, sans-serif"},"className":"__className_11930e","variable":"__variable_11930e"};